import { EdgeCreateCheckoutSessionRepository } from '@/modules/auth/infra/repositories'
import { makeSupabaseEdgeHttpClient } from '@/main/factories/http'
import type { CreateCheckoutSession } from '@/modules/auth/use-cases'

export function makeCreateCheckoutSession(): CreateCheckoutSession {
  return new EdgeCreateCheckoutSessionRepository(makeSupabaseEdgeHttpClient()).execute
}
